import React from 'react'
import { DownloadCloud as DownloadCloudIcon } from 'react-feather'
import { Box, Button } from '@material-ui/core'

import Text from '../Text'

import theme from 'theme'
import useStyles from './styles'

const FilePage = ({ title, description, fileUrl }) => {
  const classes = useStyles()

  const handleButtonAction = () => window.open(fileUrl, '_blank')

  return (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      gridGap={theme.spacing(2)}
    >
      <Text fontSize="4vh" variant="h4">
        {title}
      </Text>
      <Text fontSize="2vh" variant="h4">
        {description}
      </Text>
      <Box display="flex" justifyContent="center" py={4}>
        <Button
          className={classes.button}
          startIcon={<DownloadCloudIcon />}
          variant="contained"
          color="secondary"
          onClick={handleButtonAction}
        >
          Baixar documento
        </Button>
      </Box>
    </Box>
  )
}

export default FilePage
